const WaSaGuidelines = `
<h5>1. This Guideline:</h5>

<p>Provides the state requirements on light vehicle dimension limits in Queensland. Use these vehicle loading limits in conjunction with the Detailed Pickup Guidelines.</p>

<h5>2. Roof Rack Capacities</h5>

<p>Utes with 2-3 racks - Guide: 100 kg max.<br />
Sedans, vans and wagons - Guide: 50 kg max.</p>

<p>Vehicles are not to be overloaded. Unless the driver has obtained written verification of the rack and vehicle, where a load exceeds 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks), the driver must take into account factors particular to the individual vehicle to determine whether or not the product may be loaded.</p>

<p>BlueScope will not accept liability for loss or claims arising from drivers accepting loads of more than 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks).</p>

<h5>3. Overhang Requirements</h5>

<p>The standard lengths of our tubular products are 8.0 metres. The majority of trade cars and utes are unable to support this length.</p>

<ul>
	<li>Front overhangs must be less than 1.2 metres from the front anchor point.</li>
	<li>Rear Overhangs must be the lesser of 3.7 metres or 60% of the vehicle's wheelbase.</li>
	<li>Side overhangs must not exceed more than 150mm from the edge of the vehicle, with a maximum load width of 2.5 metres.</li>
</ul>

<p>Maximum vehicle and product length permitted is 12.5 metres</p>

<p>In all situations, the driver's vision must not be obstructed.<br />
<strong>Projections /overhangs that are dangerous are not acceptable.</strong></p>

<p>For daytime travel, a bright coloured flag is required on any overhang that cannot be easily seen. A flag is mandatory for rear overhangs beyond 1.2 metres past the end of a vehicle or trailer.</p>

<h5>4. Trailers</h5>

<p>Towing a trailer does not change the amount of rear projection that is permitted on the tow vehicle.<br />
Maximum product and vehicle combination must not exceed 19 metres.<br />
Please refer to the Detailed Pickup Guidelines for overhang measurements for trailers.<br />
The front projection must be within the drawbar area.</p>

<h5>5. Load Restraint</h5>

<p>Please ensure your load restraint equipment and method is suitable for products.</p>

<p>Tie-down (using lashings to tie down the load) is the most common method of load restraint.<br />
The load is prevented from moving by the friction between the load and vehicle, created by the weight of the load and pressure from the tie-down lashings.<br />
Tie-down lashings include webbing straps, chains and ropes.<br />
These are tensioned to clamp the load down.<br />
Rope is a non-preferred lashing and needs to be used with caution. Ropes should only be considered for light weight product.</p>

<p>VEHICLES CONSIDERED INAPPROPRIATE CANNOT BE LOADED!<br />
YOUR SAFETY IS OUR CONCERN</p>

<p>For more detailed illustrations and instructions please download our <a class="mc-blue-text" target="_blank" href="https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-07/wa-sa.pdf">Detailed Pickup Guidelines.</a></p>
`

const NswActGuidelines = `
<h5>1. This Guideline:</h5>

<p>Provides the state requirements on light vehicle dimension limits in Queensland. Use these vehicle loading limits in conjunction with the Detailed Pickup Guidelines.</p>

<h5>2. Roof Rack Capacities</h5>

<p>Utes with 2-3 racks - Guide: 100 kg max.<br />
Sedans, vans and wagons - Guide: 50 kg max.</p>

<p>Vehicles are not to be overloaded. Unless the driver has obtained written verification of the rack and vehicle, where a load exceeds 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks), the driver must take into account factors particular to the individual vehicle to determine whether or not the product may be loaded.</p>

<p>BlueScope will not accept liability for loss or claims arising from drivers accepting loads of more than 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks).</p>

<h5>3. Overhang Requirements</h5>

<p>For vehicles up to 9.5 metres in length.</p>

<ul>
	<li>Front overhangs must be less than 1.2 metres from the front anchor point.</li>
	<li>Rear Overhangs must be less than 1.2 metres from the rear of the vehicle.</li>
</ul>

<p>The rear projection may exceed 1.2 metres where the total length of the loaded vehicle does not exceed 12.5 metres and the rigidity of the product permits.</p>

<p>For vehicles greater than 9.5 metres in length.</p>

<ul>
	<li>Front overhangs must be less than 1.2 metres from the front anchor point.</li>
	<li>Rear Overhangs must be less than 4.0 metres from the rear axil of the vehicle.</li>
	<li>Maximum vehicle and load length cannot exceed 12.5 metres</li>
	<li>Side overhangs must not exceed more than 150mm from the edge of the vehicle, with a maximum load width of 2.5 metres.</li>
</ul>

<p>In all situations, the driver's vision must not be obstructed.<br />
<strong>Projections /overhangs that are dangerous are not acceptable.</strong></p>

<p>For daytime travel, a bright coloured 300mm squared flag is required on any overhang that cannot be easily seen. A flag is mandatory for rear overhangs beyond 1.2 metres past the end of a vehicle or trailer.</p>

<h5>4. Trailers</h5>

<p>Towing a trailer does not change the amount of rear projection that is permitted on the tow vehicle.<br />
Maximum product and vehicle combination must not exceed 19 metres.<br />
Please refer to the Detailed Pickup Guidelines for overhang measurements for trailers.<br />
The front projection must be within the drawbar area.</p>

<h5>5. Load Restraint</h5>

<p>Please ensure your load restraint equipment and method is suitable for products.</p>

<p>Tie-down (using lashings to tie down the load) is the most common method of load restraint.<br />
The load is prevented from moving by the friction between the load and vehicle, created by the weight of the load and pressure from the tie-down lashings.<br />
Tie-down lashings include webbing straps, chains and ropes.<br />
These are tensioned to clamp the load down.<br />
Rope is a non-preferred lashing and needs to be used with caution. Ropes should only be considered for light weight product.</p>

<p>VEHICLES CONSIDERED INAPPROPRIATE CANNOT BE LOADED!<br />
YOUR SAFETY IS OUR CONCERN</p>

<p>For more detailed illustrations and instructions please download our <a class="mc-blue-text" target="_blank" href="https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-07/nsw-act.pdf">Detailed Pickup Guidelines.</a></p>

`

const QldGuidelines = `
<h5>1. This Guideline:</h5>

<p>Provides the state requirements on light vehicle dimension limits in Queensland. Use these vehicle loading limits in conjunction with the Detailed Pickup Guidelines.</p>

<h5>2. Roof Rack Capacities</h5>

<p>Utes with 2-3 racks - Guide: 100 kg max.<br />
Sedans, vans and wagons - Guide: 50 kg max.</p>

<p>Vehicles are not to be overloaded. Unless the driver has obtained written verification of the rack and vehicle, where a load exceeds 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks), the driver must take into account factors particular to the individual vehicle to determine whether or not the product may be loaded.</p>

<p>BlueScope will not accept liability for loss or claims arising from drivers accepting loads of more than 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks).</p>

<h5>3. Overhang Requirements</h5>

<p>The standard lengths of our tubular products are 8.0 metres. The majority of trade cars and utes are unable to support this length.</p>

<ul>
	<li>Front overhangs must be less than 1.2 metres from the front anchor point.</li>
	<li>Rear Overhangs must be the lesser of 3.7 metres or 60% of the vehicle's wheelbase.</li>
	<li>Side overhangs must not exceed more than 150mm from the edge of the vehicle, with a maximum load width of 2.5 metres.</li>
</ul>

<p>Maximum vehicle and product length permitted is 12.5 metres</p>

<p>In all situations, the driver's vision must not be obstructed.<br />
<strong>Projections /overhangs that are dangerous are not acceptable.</strong></p>

<p>For daytime travel, a minimum 450mm square bright coloured red, red and yellow or yellow flag is required on any overhang that cannot be easily seen. This is mandatory for rear overhangs beyond 1.2 metres past the end of a vehicle or trailer.</p>

<h5>4. Trailers</h5>

<p>Towing a trailer does not change the amount of rear projection that is permitted on the tow vehicle.<br />
Maximum product and vehicle combination must not exceed 19 metres.<br />
Please refer to the Detailed Pickup Guidelines for overhang measurements for trailers.<br />
Always allow 300mm clearance from any contact point of the turning vehicle.</p>

<h5>5. Load Restraint</h5>

<p>Please ensure your load restraint equipment and method is suitable for products.</p>

<p>Tie-down (using lashings to tie down the load) is the most common method of load restraint.<br />
The load is prevented from moving by the friction between the load and vehicle, created by the weight of the load and pressure from the tie-down lashings.<br />
Tie-down lashings include webbing straps, chains and ropes.<br />
These are tensioned to clamp the load down.<br />
Rope is a non-preferred lashing and needs to be used with caution. Ropes should only be considered for light weight product.</p>

<p>VEHICLES CONSIDERED INAPPROPRIATE CANNOT BE LOADED!<br />
YOUR SAFETY IS OUR CONCERN</p>

<p>For more detailed illustrations and instructions please download our <a class="mc-blue-text" target="_blank" href="https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-07/qld.pdf">Detailed Pickup Guidelines.</a></p>
`

const VicNtGuidelines = `
<div class="guidelines-description">
<h5>1. This Guideline:</h5>

<p>Provides the state requirements on light vehicle dimension limits in Queensland. Use these vehicle loading limits in conjunction with the <a class="mc-blue-text" target="_blank" href="http://metalcorp.lndo.site/profiles/custom/metalcorp/themes/custom/metalcorp_main/assets/guidelines/nt-vic.pdf">Detail Pickup Guidelines</a>.</p>

<h5>2. Roof Rack Capacities</h5>

<p>Utes with 2-3 racks - Guide: 100 kg max.<br>
Sedans, vans and wagons - Guide: 50 kg max.</p>

<p>Vehicles are not to be overloaded. Unless the driver has obtained written verification of the rack and vehicle, where a load exceeds 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks), the driver must take into account factors particular to the individual vehicle to determine whether or not the product may be loaded.</p>

<p>BlueScope will not accept liability for loss or claims arising from drivers accepting loads of more than 50 kg (for sedans, vans and wagons) or 100 kg (for utes with trade racks).</p>

<h5>3. Overhang Requirements</h5>

<p>The standard lengths of our tubular products are 8.0 metres. The majority of trade cars and utes are unable to support this length.</p>

<ul>
<li>Front overhangs must be less than 1.2 metres from the front anchor point.</li>
<li>Rear Overhangs must be the lesser of 3.7 metres or 60% of the vehicle's wheelbase.</li>
<li>A maximum of 1.2 metres for vehicles less than 4.5 tonne GVM in Victoria (provided the rear overhang is less than 3.7 metres or 60% of the wheel base)</li>
<li>Side overhangs must not exceed more than 150mm from the edge of the vehicle, with a maximum load width of 2.5 metres.</li>
</ul>

<p>In all situations, the driver's vision must not be obstructed.<br>
<strong>Projections /overhangs that are dangerous are not acceptable.</strong></p>

<p>For daytime travel, a bright coloured 300mm squared flag is required on any overhang that cannot be easily seen. A flag is mandatory for rear overhangs beyond 1.2 metres past the end of a vehicle or trailer.</p>

<h5>4. Trailers</h5>

<p>Towing a trailer does not change the amount of rear projection that is permitted on the tow vehicle.<br>
Maximum product and vehicle combination must not exceed 19 metres.<br>
Please refer to the <a class="mc-blue-text" target="_blank" href="https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-07/nt-vic.pdf">Detail Pickup Guidelines</a> for overhang measurements for trailers.<br>
The front projection must be within the drawbar area.</p>

<h5>5. Load Restraint</h5>

<p>Please ensure your load restraint equipment and method is suitable for products.</p>

<p>Tie-down (using lashings to tie down the load) is the most common method of load restraint.<br>
The load is prevented from moving by the friction between the load and vehicle, created by the weight of the load and pressure from the tie-down lashings.<br>
Tie-down lashings include webbing straps, chains and ropes.<br>
These are tensioned to clamp the load down.<br>
Rope is a non-preferred lashing and needs to be used with caution. Ropes should only be considered for light weight product.</p>

<p>VEHICLES CONSIDERED INAPPROPRIATE CANNOT BE LOADED!<br>
YOUR SAFETY IS OUR CONCERN</p>

<p>For more detailed illustrations and instructions please download our <a class="mc-blue-text" target="_blank" href="https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-07/nt-vic.pdf">Detail Pickup Guidelines</a>.</p>

</div>`


export default {
  WA: WaSaGuidelines,
  SA: WaSaGuidelines,
  NSW: NswActGuidelines,
  ACT: NswActGuidelines,
  VIC: VicNtGuidelines,
  TAS: VicNtGuidelines,
  NT: VicNtGuidelines,
  QLD: QldGuidelines
}